// @flow
import * as React from 'react';
import { defineMessages, injectIntl, IntlShape } from 'react-intl';
import HorizontalLine from 'esm-web-pro/components/layout/HorizontalLine';
import { isEmpty, sortBy } from 'lodash';
import MeatballsIcon from 'esm-web-pro/components/layout/sidePanel/icons/MeatballsIcon';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import DamageIcon from 'esm-web-pro/components/layout/sidePanel/icons/DamageIcon';
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';
import RowActions from 'esm-web-pro/components/layout/sidePanel/RowActions';
import { withRouter } from 'react-router-dom';
import ContentLabel from 'esm-web-pro/components/layout/sidePanel/ContentLabel';
import ValueText from 'esm-web-pro/components/layout/sidePanel/ValueText';


type Props = {
    pipes: Object,
    intl: IntlShape,
    onSplitPipe: Function,
    history: Object,
    match: Object,
    map: Object,
    clickedRow: ?string,
    handleHighlight: (pipe: Object, isContinuous: boolean) => void,
    point11: Object,
};

const msg = defineMessages({
    transit: {
        id: 'transit-pipes',
        defaultMessage: 'Transit',
    },
    noTransit: {
        id: 'no-transit-pipes',
        defaultMessage: 'No transit pipes.',
    },
});

const TransitPipesList = (props: Props) => {
    const {
        intl: { formatMessage }, pipes, onSplitPipe, history: { push }, match: { url },
        map: networkMap, clickedRow, handleHighlight, point11,
    } = props;

    return (
        <>
            <ContentLabel>{formatMessage(msg.transit)}</ContentLabel>
            <HorizontalLine color="#D6D7DA" />
            {(isEmpty(pipes)) && (
                <ContentRow padLevel={1}>
                    <ValueText>
                        {formatMessage(msg.noTransit)}
                    </ValueText>
                </ContentRow>
            )}
            {sortBy(pipes, ['sequence']).map((pipe) => {
                const actions = [
                    {
                        key: `pipe-${pipe.id}-more`,
                        icon: <MeatballsIcon />,
                        size: '20px',
                        width: '3px',
                        callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                            e.stopPropagation();
                            const path = url.split('/layer');
                            push(`${path[0]}/layer/continuousPipe/${pipe.identity}`);
                        },
                        tooltip: formatMessage(actionMessages.more),
                    },
                ];

                if (networkMap.is_draft && point11.type !== 'fork') {
                    actions.unshift({
                        key: `pipe-${pipe.id}-split`,
                        icon: <DamageIcon />,
                        size: '20px',
                        width: '3px',
                        callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                            e.stopPropagation();
                            onSplitPipe(pipe);
                        },
                        tooltip: formatMessage(actionMessages.split),
                    });
                }

                return (
                    <ContentRow
                        key={`transit-pipe-row-${pipe.uuid}`}
                        actions={<RowActions actions={actions} />}
                        onClick={() => handleHighlight(pipe, true)}
                        rowId={`pipe-${pipe.id}`}
                        clickedRowIdentity={clickedRow}
                        padLevel={1}
                    >
                        <ValueText>{pipe.ref}</ValueText>
                    </ContentRow>
                );
            })}
        </>
    );
};

export default injectIntl(withRouter(TransitPipesList));
